import * as types from "./validar.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";

export default {
  setTokenRecaptcha: data => ({
    type: types.SET_TOKEN_RECAPTCHA,
    payload: data
  }),
  validate: data => ({
    type: types.VALIDATE,
    payload: data
  }),
  setFromQueryString: data => ({
    type: types.SET_FROM_QUERY_STRING,
    payload: data
  }),
  setDadosAmbulante: data => ({
    type: types.SET_DADOS_AMBULANTE,
    payload: data
  }),
  getDadosAmbulante: data => ({
    type: types.GET_DADOS_AMBULANTE,
    payload: data
  })
};
